import styled from "styled-components";
import { DescriptiveBlockWrapped } from "../../components/descriptiveBlock";
import { NewsLetter } from "../../components/newsLetter";
import { MonthlyOffers } from "../home/monthlyOffers";
import { RoundedInfo } from "../../components/roundedInfo";
import { FiscoTable } from "./fiscoTable";
import { useCopertinaQuery } from "../../generated/graphql";

const ImgBanner = styled.img`
  width: 100%;
  height: auto;
`;

export function Fisco() {
  const [copertina] = useCopertinaQuery({
    variables: { id: "1Q3PqA04DvDgIsWgnu2Ul6" },
  });
  return (
    <>
      <ImgBanner
        src={copertina.data?.copertina?.copertina?.url || ""}
      ></ImgBanner>
      <DescriptiveBlockWrapped id="6sMzvsPkboKVOPDUPWQgw" />
      <FiscoTable />
      <MonthlyOffers id="7nZE1vjk1hSdsGyWpb7c8G" size={3} />
      <RoundedInfo id="6UWfZxMMgpLX9mbeCdohIZ"></RoundedInfo>

      <NewsLetter />
    </>
  );
}
